<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Youtube URL',
              modelPath: [this, 'form', 'youtube_url'],
              required: true
            }),
            new fields.Input({
              label: 'Video start time (in seconds)',
              modelPath: [this, 'form', 'video_start'],
              type: 'number'
            })
          ]
        }
      ]
    }
  }
}
</script>
